import { render } from "./TwoFactorSetup.vue?vue&type=template&id=1c07f80b&ts=true"
import script from "./TwoFactorSetup.vue?vue&type=script&lang=ts"
export * from "./TwoFactorSetup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__